<template>
  <div v-if="show" class="loading-container">
    <div class="loading-mask"></div>
    <div class="loading-content">
      <i class="loading-dot-item"></i>
      <i class="loading-dot-item"></i>
      <i class="loading-dot-item"></i>
      <i class="loading-dot-item"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-container{
  position: relative;
  text-align: center;
  z-index: 1002;
  .loading-mask{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgb(255, 255, 255);
    opacity: 0.5;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
  .loading-content{
    width: 20px;
    height: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    transform: rotate(45deg);
    -webkit-animation: antRotate 1.2s infinite linear;
    animation: antRotate 1.2s infinite linear;
    .loading-dot-item{
      position: absolute;
      display: block;
      width: 9px;
      height: 9px;
      background-color: #1890ff;
      border-radius: 100%;
      transform: scale(0.75);
      transform-origin: 50% 50%;
      opacity: 0.3;
      -webkit-animation: antSpinMove 1s infinite linear alternate;
      animation: antSpinMove 1s infinite linear alternate;
      &:nth-child(1){
        top: 0;
        left: 0;
      }
      &:nth-child(2){
        top: 0;
        right: 0;
        -webkit-animation-delay: 0.4s;
        animation-delay: 0.4s;
      }
      &:nth-child(3){
        bottom: 0;
        right: 0;
        -webkit-animation-delay: 0.8s;
        animation-delay: 0.8s;
      }
      &:nth-child(4){
        bottom: 0;
        left: 0;
        -webkit-animation-delay: 1.2s;
        animation-delay: 1.2s;
      }
    }
  }
}
</style>
